import React, { useState } from "react";
import { unwrapResult } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import { updatelocalUser, updateUsers } from "../../3- actions/users";
import Compress from "react-image-file-resizer";
import { RiFileEditFill } from "@react-icons/all-files/ri/RiFileEditFill";
import { AiOutlinePlus } from "@react-icons/all-files/ai/AiOutlinePlus";

function UserDashboardCrud({
  popUp,
  setPopup,
  formData,
  setFormData,
  currentUser,
  LocalUser,
}) {
  const dispatch = useDispatch();
  const [submitComment, setSubmitComment] = useState(false);
  const [error, setError] = useState(false);
  const onFileResize = (e) => {
    const file = e.target.files[0];
    Compress.imageFileResizer(
      file, // the file from input
      250, // width
      250, // height
      "WEBP", // compress format WEBP, JPEG, PNG
      80, // quality
      0, // rotation
      (uri) => {
        console.log("uri", uri);
        setFormData({ ...formData, picture: uri });
        // You upload logic goes here
      },
      "base64" // blob or base64 default base64
    );
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const novelDataFavorites = {
      userId: LocalUser._id,
      obj: {
        ...formData,
      },
    };
    setSubmitComment(true);
    if (formData?.bio?.length < 5) {
      setError(true);
      setSubmitComment(false);
    } else if (formData.bio !== undefined) {
      dispatch(updatelocalUser(novelDataFavorites))
        .then(unwrapResult)
        .then(() => {
          dispatch(updateUsers(novelDataFavorites));
          setPopup(false);
          setSubmitComment(false);
        })
        .catch((err) => {
          setPopup(true);
          setSubmitComment(false);
        });
    }
  };

  return (
    <div>
      {/* popup */}
      <div
        onClick={() => {
          setPopup(false);
        }}
        className={
          popUp
            ? "absolute z-[1001] purple-full-width  backdrop-blur-[10px] bg-secondary/20 top-0 left-0 h-full w-full opacity-100  duration-500 ease-in-out"
            : "absolute z-[1001] purple-full-width  backdrop-blur-[10px] bg-secondary/20 top-0 left-0 h-full w-full opacity-0 pointer-events-none duration-500 ease-in-out"
        }
      ></div>
      <div
        className={
          popUp
            ? "  -translate-y-[0%]  opacity-100 w-full md:w-full lg:w-[75%] xl:w-[60%]  2xl:w-[50%] h-full md:h-fit  m-auto duration-500 ease-in-out fixed inset-0 z-[10001] flex justify-center items-center"
            : "  translate-y-[200%] opacity-0  w-full md:w-full lg:w-[75%] xl:w-[60%]  2xl:w-[50%] h-full md:h-fit  m-auto duration-500 ease-in-out fixed inset-0 z-[10001] flex justify-center items-center"
        }
      >
        <div className="w-full md:w-full lg:w-full xl:w-full  2xl:w-full h-full md:h-full">
          <div className="relative md:static px-[15px] w-full h-full  overflow-y-scroll flex justify-center items-start md:items-center py-28 md:py-0 md:px-0 z-[1000] bg-tertiary duration-500 ease-in-out">
            <div className="md:px-[60px] md:my-[90px] w-full">
              <form
                onSubmit={handleSubmit}
                className="relative mt-[50px] w-full h-full"
              >
                <div className="absolute z-20 top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 border-tertiary border-[10px] rounded-full">
                  <div className="h-[95px] w-[95px] md:h-[140px] md:w-[140px] sm:h-[100px] sm:w-[100px] m-auto duration-500 ease-in-out rounded-full">
                    {currentUser?.users?.picture && !formData.picture ? (
                      <div className="relative w-full h-full bg-secondary rounded-full duration-500 ease-in-out">
                        <img
                          className="object-cover w-full h-full rounded-full"
                          src={currentUser?.users?.picture}
                          alt={currentUser?.users?.firstName}
                        />
                        {currentUser?.users?._id === LocalUser._id && (
                          <label>
                            <div className="hidden">
                              <input
                                type="file"
                                id="file"
                                accept="image/*"
                                onChange={onFileResize}
                              />
                            </div>
                            <div className="cursor-pointer border-[5px] border-tertiary rounded-full scale-[1] hover:scale-[1.05]  duration-500 ease-in-out absolute top-[-20%] right-[-20%] md:top-[0%] md:right-[0%]  translate-x-[20%] md:translate-x-[5%]">
                              <div className="bg-primary flex justify-center items-center w-10 h-10 rounded-full ">
                                <RiFileEditFill className="text-tertiary text-[16px]" />
                              </div>
                            </div>
                          </label>
                        )}
                      </div>
                    ) : formData.picture ? (
                      <div className="relative  flex uppercase justify-center items-center bg-primary h-full w-full rounded-full   rectangle duration-[0] ease-in-out object-cover">
                        <img
                          src={formData.picture}
                          alt={formData.picture}
                          className="rounded-full object-cover w-full h-full pointer-events-none"
                        />
                        {currentUser?.users?._id === LocalUser._id && (
                          <label>
                            <div className="hidden">
                              <input
                                type="file"
                                id="file"
                                accept="image/*"
                                onChange={onFileResize}
                              />
                            </div>
                            <div className="cursor-pointer border-[5px] border-tertiary rounded-full  scale-[1] hover:scale-[1.05] duration-500 ease-in-out absolute top-[-20%] right-[-20%] md:top-[0%] md:right-[0%] ">
                              <div className="bg-primary flex justify-center items-center w-10 h-10 rounded-full">
                                <RiFileEditFill className="text-tertiary text-[16px]" />
                              </div>
                            </div>
                          </label>
                        )}
                      </div>
                    ) : (
                      <div className="relative  flex uppercase justify-center items-center bg-primary h-full w-full rounded-full   rectangle duration-[0] ease-in-out object-cover">
                        <div className="scale-[1.2] md:scale-[2] leading-10 pointer-events-none">
                          {currentUser?.users?.firstName?.[0]}
                        </div>
                        {currentUser.users?._id === LocalUser?._id && (
                          <label className="">
                            <div className="hidden">
                              <input
                                type="file"
                                id="file"
                                accept="image/*"
                                onChange={onFileResize}
                              />
                            </div>
                            <div className="cursor-pointer border-[5px] border-tertiary rounded-full scale-[1] hover:scale-[1.05] duration-500 ease-in-out absolute top-[-20%] right-[-20%] md:top-[0%] md:right-[0%] ">
                              <div className="bg-primary flex justify-center items-center w-10 h-10 rounded-full ">
                                <RiFileEditFill className="text-tertiary text-[16px]" />
                              </div>
                            </div>
                          </label>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-y-4">
                  <div className="relative">
                    <input
                      className="text-[14px] sm:text-[16px]  resize-none py-24 text-center text-left h-fit text-secondary capitalize w-full outline-none bg-primarys placeholder:text-secondary/60"
                      type="text"
                      placeholder="Bio..."
                      value={formData?.bio || ""}
                      onChange={(e) => {
                        setFormData({ ...formData, bio: e.target.value });
                      }}
                      maxLength={50}
                    />
                    <div
                      className={
                        formData?.bio?.length === 50
                          ? "text-primary text-[14px] sm:text-[16px]  absolute bottom-0 right-0 py-4 md:py-6 px-4 md:px-8"
                          : "text-secondary text-[14px] sm:text-[16px]  absolute bottom-0 right-0 py-4 md:py-6 px-4 md:px-8"
                      }
                    >
                      {formData?.bio?.length}/50
                    </div>
                  </div>
                  <button
                    disabled={submitComment}
                    className="z-10 font-SoraS Purple-btn-effect bg-primary hover:bg-primary/90 duration-500 ease-in-out relative w-full h-[52px] text-tertiary capitalize cursor-pointer"
                  >
                    {submitComment ? <Loading /> : "Update Profile"}
                  </button>
                </div>
              </form>
              {/* errors */}
              <div>
                <div
                  className={
                    error
                      ? "bg-error text-[14px] sm:text-[16px]  capitalize opacity-100 duration-500 ease-in-out translate-y-0  w-full py-4 flex items-center px-4 md:px-8 text-tertiary md:mt-6 mt-8"
                      : "bg-error text-[14px] sm:text-[16px]  pointer-events-none opacity-0 -translate-y-10 duration-500 ease-in-out capitalize  w-full h-0 flex items-center px-4 md:px-8 text-tertiary  mt-0"
                  }
                >
                  <h5>Your bio must be at least 5 Characters!</h5>
                </div>
              </div>
            </div>
            <div
              onClick={() => {
                setPopup(false);
              }}
              className=" cursor-pointer absolute bg-error hover:bg-error/90 duration-500 ease-out w-[50px] md:w-[70px] h-[50px] md:h-[70px] top-0 right-0 translate-y-[40%] -translate-x-[15px] md:-translate-y-1/2 md:-translate-x-[40%] flex justify-center items-center"
            >
              <AiOutlinePlus className="flex justify-center items-center text-tertiary scale-[1.5] md:scale-[2] rotate-45" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserDashboardCrud;
function Loading() {
  return (
    <div className="flex justify-center items-center scale-75">
      <div role="status">
        <svg
          aria-hidden="true"
          className=" w-8 h-8 text-tertiary animate-spin fill-primary"
          viewBox="0 0 100 101"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor"
          ></path>
          <path
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="currentFill"
          ></path>
        </svg>
      </div>
      <span className="pl-4">Loading...</span>
    </div>
  );
}
